'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _gridUtils = require('../../utils/grid/gridUtils');

var _propsComparisons = require('../../utils/react/propsComparisons');

var _ElementImage = require('../../components/images/ElementImage');

var _ElementImage2 = _interopRequireDefault(_ElementImage);

var _imageConstants = require('../../../common/images/imageConstants');

var _elementConstants = require('../../../common/elements/elementConstants');

var _mediaConstants = require('../../../common/media/mediaConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Utils


// Components


// Constants


var getFullSizeImageUrl = function getFullSizeImageUrl(element) {
    return element.getIn(['content', 'image', _imageConstants.IMAGE_SIZES.ORIGINAL.name]) || element.getIn(['content', 'image', _imageConstants.IMAGE_SIZES.HUGE.name]);
};

// Prop comparisons
var isNoLongerEditing = (0, _propsComparisons.noLonger)('isEditing');

/**
 * Renders a 'ProgressiveImage' for an element.
 * If the element has image data the progressive image will use the thumbnail from the image data, otherwise it will
 * use the data from the element's attachment as it must have just been uploaded.
 *
 * NOTE: This component should ONLY be used when there is actually image data (either in the element's content or
 * attachment).  If it doesn't have data this component will not display correctly.
 *
 * @param element {Object} The element object from the redux store.
 * @param showProgressive {Boolean} Whether to show a progressive image or standard image.
 */

var ImageRenderer = function (_React$Component) {
    _inherits(ImageRenderer, _React$Component);

    function ImageRenderer(props) {
        _classCallCheck(this, ImageRenderer);

        var _this = _possibleConstructorReturn(this, (ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call(this, props));

        _this.openFullSizeImage = _this.openFullSizeImage.bind(_this);
        return _this;
    }

    _createClass(ImageRenderer, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(oldProps) {
            if (isNoLongerEditing(oldProps, this.props) && this.props.isSelected) {
                this.refs.imageRenderer.focus();
            }
        }
    }, {
        key: 'openFullSizeImage',
        value: function openFullSizeImage(event) {
            event.preventDefault();

            var element = this.props.element;

            var imageURL = getFullSizeImageUrl(element);
            if (!imageURL) return;

            window.open(imageURL, '_blank');
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                element = _props.element,
                isHovered = _props.isHovered,
                canDrop = _props.canDrop,
                handleKey = _props.handleKey,
                gridSize = _props.gridSize,
                documentMode = _props.documentMode;


            var size = element.getIn(['content', 'width']) || _elementConstants.ELEMENT_DEFAULT_WIDTH;
            var width = documentMode ? _imageConstants.DOC_MODE_IMAGE_WIDTH : (0, _gridUtils.gridPointsToPixels)(size, gridSize);

            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('focusable', { canDrop: isHovered && canDrop }),
                    ref: 'imageRenderer',
                    tabIndex: '-1',
                    onKeyDown: handleKey,
                    onDoubleClick: this.openFullSizeImage },
                _react2.default.createElement(_ElementImage2.default, { element: element, imageType: _mediaConstants.IMAGE_TYPES.ELEMENT, size: width })
            );
        }
    }]);

    return ImageRenderer;
}(_react2.default.Component);

ImageRenderer.propTypes = {
    gridSize: _propTypes2.default.number,
    element: _propTypes2.default.object.isRequired,
    isHovered: _propTypes2.default.bool,
    canDrop: _propTypes2.default.bool,

    size: _propTypes2.default.number,

    isSelected: _propTypes2.default.bool,
    isEditing: _propTypes2.default.bool,

    handleKey: _propTypes2.default.func,
    startEditing: _propTypes2.default.func,
    stopEditing: _propTypes2.default.func,
    saveContent: _propTypes2.default.func,
    textContent: _propTypes2.default.string,
    showCaption: _propTypes2.default.func,
    onEmptyBackspace: _propTypes2.default.func,
    documentMode: _propTypes2.default.bool
};

exports.default = ImageRenderer;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/image/ImageRenderer.js
// module id = 1981
// module chunks = 0